import { render, staticRenderFns } from "./ordini.vue?vue&type=template&id=116ea177&scoped=true&lang=html"
import script from "./ordini.vue?vue&type=script&lang=js"
export * from "./ordini.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116ea177",
  null
  
)

export default component.exports